import { PasswordCodes } from '../../models/password'
import { request } from './auth-actions'
import {
  PASSWORD_RESET_STATUS,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESS,
  CLEAR_PASSWORD,
  NOTIFY_DANGER,
  NOTIFY_SUCCESS,
  LOGIN_WITH_TEMP_PASSWORD_SUCCESS,
} from './action-types'
import { getText } from '../../internal/TextLabels'
import { notify } from './notification-actions'
import authServiceApi from '../../api/auth-service-api'

export const passwordResetStatus = error => ({
  error,
  type: PASSWORD_RESET_STATUS,
})

export const setPasswordSuccess = () => ({ type: SET_PASSWORD_SUCCESS })

export const setPasswordError = error => ({ error, type: SET_PASSWORD_FAILED })

export const resetUserPasswordSuccess = password => ({
  password,
  type: RESET_PASSWORD_SUCCESS,
})

export const clearPassword = () => ({ type: CLEAR_PASSWORD })

export const loginTempPasswordSuccess = () => ({
  type: LOGIN_WITH_TEMP_PASSWORD_SUCCESS,
})

const notifySetPasswordSuccess = () => {
  notify(NOTIFY_SUCCESS, getText('password.saved'))
}

const notifySetPasswordError = errorMsg => {
  if (errorMsg.code === PasswordCodes.AUTH_FAILED) {
    notify(NOTIFY_DANGER, getText('password.error.resetLinkTimedOut'))
  } else {
    notify(NOTIFY_DANGER, getText('password.error.generic'))
  }
}

export const setPassword = (token, passwordData) => dispatch => {
  return authServiceApi
    .resetPassword(JSON.stringify(passwordData), token)
    .then(() => {
      dispatch(setPasswordSuccess())
      notifySetPasswordSuccess()
      dispatch(loginTempPasswordSuccess())
    })
    .catch(error => {
      let errorMsg
      if (error.data.code && error.data.message) {
        errorMsg = {
          code: parseInt(error.data.code, 10),
          message: error.data.message,
        }
      } else {
        errorMsg = {
          code: PasswordCodes.INTERNAL_ERROR,
          message: 'Invalid response object',
        }
      }
      dispatch(setPasswordError(errorMsg))
      notifySetPasswordError(errorMsg)
      throw error
    })
}

export const forgotPassword =
  (email, language = null) =>
  dispatch => {
    return authServiceApi
      .forgotPassword(email, language)
      .then(() => {
        // A token has been sent to the given user
        dispatch(resetUserPasswordSuccess())
        notify(NOTIFY_SUCCESS, getText('password.resetLink', email))
      })
      .catch(error => {
        notify(NOTIFY_DANGER, getText('password.failReset'))
        throw error
      })
  }

export const resetUserPassword = (userId, email, language) => dispatch => {
  return dispatch(
    request(authServiceApi.resetUserPassword, { userId, language }),
  )
    .then(response => {
      if (response.status === 201) {
        // A one time password has been generated, since the user did not have an email address.
        response
          .json()
          .then(data => dispatch(resetUserPasswordSuccess(data.password)))
      } else if (response.status === 204) {
        // A reset token has been sent to the given user
        dispatch(resetUserPasswordSuccess())
        notify(NOTIFY_SUCCESS, getText('password.resetLink', email))
      } else {
        notify(NOTIFY_DANGER, getText('password.failReset'))
      }
    })
    .catch(error => {
      notify(NOTIFY_DANGER, getText('password.failReset'))
      throw error
    })
}
